import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9","key":"svg-0"}],["path",{"d":"M7.5 12a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0","key":"svg-1"}]]

const IconPlaystationCircle = createReactComponent('outline', 'playstation-circle', 'PlaystationCircle', __iconNode);

export default IconPlaystationCircle;